import {SurveyElement} from '../survey/ISurveyElement';
import {getElementId} from '../../lib/+state/elements/elements.reducer';
import {OptionType} from '../../lib/enum/OptionType.enum';

export interface ISurveyResponse {
    id: string;
    answerId: string;
    questionId: string;
    value: any;
    created_at: number;
    seeded?: boolean;
    languageCode?: string;
    questionKey?: string;
    answerKey?: string;
}

export class SurveyResponse implements ISurveyResponse {
    public id: string;
    public answerId: string;
    public questionId: string;
    public created_at: number;
    public recorded?: boolean;
    public seeded?: boolean;
    public languageCode?: string;

    constructor(element: SurveyElement, public value: any, answerId: string = null, createdAt: number = null, languageCode: string = null) {
        this.questionId = getElementId(element);
        // answer id is either the one provided or the question id
        this.answerId = answerId || getElementId(element);
        this.created_at = createdAt || new Date().getTime();

        this.id = this.answerId;
        this.languageCode = languageCode;
    }
}

export class SeededSurveyResponse implements ISurveyResponse {
    public created_at: number;
    public questionId: string;
    public answerId: string;
    public languageCode?: string;
    public questionKey?: string;
    public answerKey?: string;
    public value: any;

    constructor(public id: string, value: any, languageCode: string = null) {
        /**
         * check the value is string or boolean
         * string is represented for the answer key
         * boolean is represented for the value
         */
        const isStringValue = typeof value === 'string';
        this.created_at = new Date().getTime();
        this.languageCode = languageCode;
        if (isStringValue) {
            this.questionKey = id;
            this.answerKey = value;
        } else {
            this.questionId = id;
            this.answerId = id;
            this.value = value;
        }
    }
}

export class MultiSelectSurveyResponse implements ISurveyResponse {
    public questionId: string;
    public answerId: string;
    public optionType: OptionType;
    public created_at: number;
    public languageCode?: string;

    constructor(public id: string, questionId: string, public value: any, optionType: OptionType, languageCode: string = null) {
        this.answerId = id;
        this.questionId = questionId;
        this.optionType = optionType;
        this.created_at = new Date().getTime();
        this.languageCode = languageCode;
    }
}

export class YesNoSurveyResponse implements ISurveyResponse {
    public id: string;
    public answerId: string;
    public questionId: string;
    public created_at: number;
    public recorded?: boolean;
    public seeded?: boolean;
    public languageCode?: string;

    constructor(element: SurveyElement, public value: any, answerId: string = null, createdAt: number = null, languageCode: string = null) {
        this.questionId = getElementId(element);
        // answer id is either the one provided or the question id
        this.answerId = answerId || getElementId(element);
        this.created_at = createdAt || new Date().getTime();

        this.id = this.questionId;
        this.languageCode = languageCode;
    }
}

export class MultiChoiceSurveyResponse extends YesNoSurveyResponse {
    constructor(element: SurveyElement, value: any, answerId: string = null, createdAt: number = null, languageCode: string = null) {
        super(element, value, answerId, createdAt, languageCode);
    }
}

export class InputSurveyResponse implements ISurveyResponse {
    public id: string;
    public answerId: string;
    public questionId: string;
    public created_at: number;
    public recorded?: boolean;
    public seeded?: boolean;
    public languageCode?: string;

    constructor(element: SurveyElement, public value: any, answerId: string = null, createdAt: number = null, languageCode: string = null) {
        this.questionId = getElementId(element);
        this.answerId = answerId || this.questionId ;
        this.created_at = createdAt || new Date().getTime();
        this.id = this.questionId ;
        this.languageCode = languageCode;
    }
}
